import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    nameInputError: '',
    emailInputError: '',
    checkboxError: ''
};

export const formErrorsSlice = createSlice({
    name: 'formErrors',
    initialState,
    reducers: {
        setNameInputError: (state, action) => {
            state.nameInputError = action.payload;
        },
        setEmailInputError: (state, action) => {
            state.emailInputError = action.payload;
        },
        setCheckboxError: (state, action) => {
            state.checkboxError = action.payload;
        }
    }
});

export default formErrorsSlice.reducer;

export const {setNameInputError, setEmailInputError, setCheckboxError} = formErrorsSlice.actions;